webpackJsonp([164132029939027],{

/***/ 947:
/***/ (function(module, exports) {

	module.exports = {"title":"Hæfni","cards":{"Card1":{"title":"Chess Competency","button":"Sjá nánar","subtitle":"Stórmeistari í skák <br/> ELO 2580 FIDE <br/> Heimsmeistari unglinga í skák"},"Card2":{"title":"Skákþjálfara hæfni","button":"Sjá nánar","subtitle":"Hef þjálfan marga af efnilegustu skákmönnum landsins ásamt því að þjálfa í Bandaríkjunum og í Þýskalandi. <br/> FIDE Senior Trainer <br/> Þýskur A-Trainer"}}}

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactstrap = __webpack_require__(9);
	
	var _CardContainer = __webpack_require__(164);
	
	var _CardContainer2 = _interopRequireDefault(_CardContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	
	  var chess = props.data.chess.childImageSharp.sizes;
	  var training = props.data.training.childImageSharp.sizes;
	
	  var images = { card1: chess, card2: training };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactstrap.Container,
	      { className: 'my-5' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'text-center text-color-title bold' },
	        props.content.title
	      ),
	      _react2.default.createElement(_CardContainer2.default, { images: images, cardsData: props.content.cards })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__(243);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function Card(props) {
	
	    var evenIndex = props.index === '0' ? true : false;
	
	    var title = props.card.title;
	    var image = props.image;
	    var button = props.card.button;
	    var slug = props.slug;
	    var subtitle = props.card.subtitle;
	
	    var style = {
	        backgroundColor: props.backgroundColor
	    };
	
	    var cardImage = _react2.default.createElement(
	        'div',
	        { className: 'cardImg shadow', id: evenIndex ? 'right' : null, style: style },
	        _react2.default.createElement(_gatsbyImage2.default, { className: 'teach-image', sizes: image })
	    );
	
	    var cardContent = _react2.default.createElement(
	        'div',
	        { className: 'cardContent shadow', id: evenIndex ? null : 'right', style: style },
	        _react2.default.createElement(
	            'h5',
	            { className: 'cardTitle' },
	            title
	        ),
	        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: subtitle } }),
	        _react2.default.createElement(
	            _Link2.default,
	            { className: 'btn-lm btn-lg', to: slug },
	            button
	        )
	    );
	
	    var content = void 0;
	    if (evenIndex) {
	        content = _react2.default.createElement(
	            'div',
	            { className: 'cardContainer' },
	            cardImage,
	            cardContent
	        );
	    } else {
	        content = _react2.default.createElement(
	            'div',
	            { className: 'cardContainer' },
	            cardContent,
	            cardImage
	        );
	    }
	
	    return content;
	};
	
	exports.default = Card;
	module.exports = exports['default'];

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Card = __webpack_require__(163);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	__webpack_require__(244);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLinks = function ImageLinks(props) {
	    var cardsData = props.cardsData;
	    var Card1 = cardsData.Card1;
	    var Card2 = cardsData.Card2;
	
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'teach-card-container' },
	        _react2.default.createElement(_Card2.default, { card: Card1, image: props.images.card1, backgroundColor: '#00A5CF', index: '0', slug: '/competency/chess' }),
	        _react2.default.createElement(_Card2.default, { card: Card2, image: props.images.card2, backgroundColor: '#FEBD00', index: '1', slug: '/competency/training' })
	    );
	};
	
	exports.default = ImageLinks;
	module.exports = exports['default'];

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _competencyLayout = __webpack_require__(161);
	
	var _competencyLayout2 = _interopRequireDefault(_competencyLayout);
	
	var _grandmaster = __webpack_require__(947);
	
	var _grandmaster2 = _interopRequireDefault(_grandmaster);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Sk\xE1kgreind | H\xE6fni'
	      )
	    ),
	    _react2.default.createElement(_competencyLayout2.default, _extends({ content: _grandmaster2.default }, props))
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-competency-index-is-js-4d2510ae454737109684.js